module.exports = __webpack_public_path__ + "static/team-training-mobile-b9a089b6d5a37e98afbdf811bca170eb.jpg";